import React, { useState, useEffect } from 'react';
import './index.scss';

const Loader = ({ 
  size = 120, 
  backgroundColor = '#000', 
  zIndex = 1000,
  fullScreen = true 
}) => {
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    // Show spinner after logo fill animation completes
    const timer = setTimeout(() => {
      setShowSpinner(true);
    }, 1500); // Match the waterFill animation duration

    return () => clearTimeout(timer);
  }, []);

  const containerStyle = fullScreen ? {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor,
    zIndex
  } : {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor,
    zIndex
  };

  const logoSize = size;

  return (
    <div style={containerStyle}>
      <div style={{
        position: 'relative',
        width: `${logoSize}px`,
        height: `${logoSize}px`,
        marginBottom: '20px'
      }}>
        {/* Filling logo with water effect */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 2
        }}>
          {/* Background image that will be revealed by the fill */}
          <img 
            src="/logo192.png" 
            alt="Audioread" 
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1
            }}
          />
          
          {/* Water fill effect - covers the logo and reveals it from bottom */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            background: backgroundColor,
            animation: 'waterFill 1.5s ease-in-out forwards',
            zIndex: 2
          }} />
        </div>
      </div>
      
      {/* Spinner below the logo - only shown after logo fill completes */}
      {showSpinner && (
        <div style={{
          width: '30px',
          height: '30px',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTop: '3px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginTop: '10px'
        }} />
      )}
      
      <style>
        {`
          @keyframes waterFill {
            0% { 
              height: 100%; 
              background: ${backgroundColor};
            }
            100% { 
              height: 0%; 
              background: ${backgroundColor};
            }
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default Loader; 